var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMute = function SvgMute(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m5.382 4.168-1.14.517H2.928c-.58 0-1.05.47-1.05 1.05v4.528c0 .58.47 1.05 1.05 1.05H4.24l5.954 2.7a1.047 1.047 0 0 0 1.005-.075c.175-.113.31-.273.391-.457l-1.312-1.968v1L4.75 10.005a1.1 1.1 0 0 0-.433-.092h-1.04V6.087h1.04q.227 0 .434-.094l1.418-.644zm4.896 2.1V3.485l-1.425.646-.787-1.18 2.13-.966c.326-.148.7-.12 1.002.073.302.194.482.524.482.883v5.43zm3.7 5.552-.9-1.352V4.85a.7.7 0 0 1 1.4 0v6.3c0 .316-.21.584-.5.67",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.455,
    d: "m5.091 1.165 9.115 13.671"
  })));
};
export default SvgMute;